import React from 'react';
import ToastWrapper from '@/components/toasts/ToastWrapper';
import { approvedIcon } from '@/constants/images';
import ToastMessage from '@/components/toasts/ToastMessage';

const UserApprovalToast = ({ items }) => {
  const { approved } = items[0];

  return (
    <ToastWrapper
      className="aridhia-user-approval-toast"
      icon={approvedIcon(approved)}
      color={approved ? 'green' : 'red'}
    >
      <ToastMessage
        items={items}
        multiple={approved ? 'toast.users.approved' : 'toast.users.unapproved'}
        single={approved ? 'toast.user.approved' : 'toast.user.unapproved'}
      />
    </ToastWrapper>
  );
};

export default UserApprovalToast;
